
import axios from 'axios';

import React, { useEffect, useState } from 'react';

import "./Button.css";
import Home from './Home';

function Graphic() {

    const [logo, setLogo] = useState("");
    const [farbe1, setFarbe1] = useState("");
    const [farbe2, setFarbe2] = useState("");
    const [farbe3, setFarbe3] = useState("");




    // "farbe1" < background for loginComponent
    // "farbe2" < text-color
    // "farbe3" < background for Buttons/NutritionComponent (edited) 



    useEffect(() => {
        axios.get('https://login.solufind.de/funktionen/farben.json')
            .then((response) => {
                setLogo(response.data[0]);
                setFarbe1(response.data[0].farbe1);
                setFarbe2(response.data[0].farbe2);
                setFarbe3(response.data[0].farbe3);
            })
            .catch(function (error) {
                console.log(error);
            });
    }, [])



    useEffect(() => { console.log(logo['logo-2']) }, [logo])

    useEffect(() => { console.log(farbe1) }, [farbe1]);
    useEffect(() => { console.log(farbe2) }, [farbe2]);
    useEffect(() => { console.log(farbe3) }, [farbe3]);



    return (

        <div className='container' >
        
            <div className="row row-cols-4">
                <div className="col rounded float-start"><img src={logo['logo']} className="rounded float-start" alt="logo 1" />   </div>

                <div className="col rounded float-end"><img src={logo['logo-2']} className="rounded float-end" alt="logo 2" /></div>
         
                 
            </div>

        </div>

    )

}



export default Graphic;



